function carousels(backendAxiosInstance) {
  async function getCarousel({ sourceCarouselId, source, type }, filters = {}, { max } = {}) {
    return backendAxiosInstance.get("/layouts/v3/carousels", {
      includeLanguage: true,
      includeTimeZone: true,
      includeDeviceType: true,
      params: {
        sourceCarouselId,
        source,
        type,
        max,
        ...filters
      }
    });
  }
  return {
    getCarousel
  };
}

export { carousels as default };
//# sourceMappingURL=carousels.js.map
